import accessesory from '../../../assets/categories/accessories.jpg';
import powerTool from '../../../assets/categories/power-tool.jpg';
import handTool from '../../../assets/categories/hand-tool.jpg';
import outdoor from '../../../assets/categories/outdoor.jpg';
import storage from '../../../assets/categories/storage.jpg';
import cleaning from '../../../assets/categories/cleaning.jpg';
import vehicleTools from '../../../assets/categories/Vehicle-Tools.jpg';
import electric from '../../../assets/categories/electrict.jpg';
import saw from '../../../assets/categories/saw.jpg';
import workspace from '../../../assets/categories/workspace.jpg';
import join from '../../../assets/categories/join.jpg';
import lighting from '../../../assets/categories/lighting.jpg';
import hummer from '../../../assets/categories/hummer.jpg';
import cordless from '../../../assets/categories/cordless.jpg';
import woodencut from '../../../assets/categories/wooden-cut.jpg';
import clamps from '../../../assets/categories/clamps.jpg';

export const CategoriesData = [
    {
        img: accessesory,
        name: 'Accessories'
    },
    {
        img: powerTool,
        name: 'Power Tools'
    },
    {
        img: handTool,
        name: 'Hand Tools'
    },
    {
        img: outdoor,
        name: 'Outdoor'
    },
    {
        img: storage,
        name: 'Storage'
    },
    {
        img: cleaning,
        name: 'Cleaning Tools'
    },
    {
        img: vehicleTools,
        name: 'Vehicle Tools'
    },
    {
        img: electric,
        name: 'Electric Tools'
    },
    {
        img: saw,
        name: 'Cutting Tools'
    },
    {
        img: join,
        name: 'Join'
    },
    {
        img: clamps,
        name: 'Clamps & Vises'
    },
    {
        img: workspace,
        name: 'Workspace'
    },
    {
        img: hummer,
        name: 'Heavy Tools'
    },
    {
        img: cordless,
        name: 'Cordless Tools'
    },
    {
        img: lighting,
        name: 'Lighting'
    },
    {
        img: woodencut,
        name: 'Wooden tools'
    }
]